
import { request } from './_request';
import moment from 'moment'
import { currency } from '../helpers/formatter'
import { lastIndexUndefined, groupArrayOfObjects, undefinedIndexArrayToZero, averageArray } from '../helpers/ao'

export const downloadCsvData = () => {


	return (dispatch, getState) => {

		return new Promise((ready) => {

			let params = getState().reports
			let paramsMet = getState().mainMetrico

			let idReporte = params.idReporte

			dispatch({ type: 'LOADING_REPORTS', payload: true });

			let marcaUnidad = "";
			let nameCSV = "";
			if (!params.idReporte) {

				 marcaUnidad = paramsMet.nameMetrico + '_' + paramsMet.nameMarca + '_' + paramsMet.nameUnidad + '_';

				 nameCSV = marcaUnidad + moment().startOf('month').format('YYYY/MM/DD') + '_' + moment().subtract(1, "days").format("YYYY/MM/DD") + '.csv'
			} else {
				 marcaUnidad = params.marcas.find(item => item.id === params.idMarca).marcaUnidades.find(item => item.unidad_id === params.idUnidad) ?
					params.marcas.find(item => item.id === params.idMarca).marcaUnidades.find(item => item.unidad_id === params.idUnidad).descripcion + '_' :
					params.marcas.find(item => item.id === params.idMarca).nombre + '_' + 'TODO_'

				 nameCSV = marcaUnidad +
					params.reportes.find(item => item.id === params.idReporte).nombre +
					'_' + moment().startOf('month').format('YYYY/MM/DD') + '_' + moment().subtract(1, "days").format("YYYY/MM/DD") + '.csv'

			}
			let headers = params.columnsData.map(a => a.nombre);

			let indexGroup = params.columnsData.filter(item => item.group === 1)
			let groupData = []
			let values = []
			if (indexGroup.length == 1) {

				groupData = groupArrayOfObjects(params.data, indexGroup[0].index)
				values = []

				for (let key in groupData) {

					let obj = groupData[key];

					values.push([key + '(' + obj.length + ')'])
					values.push(headers)
					let total = new Array(params.columnsData.length)
					let totalProm = new Array(params.columnsData.length)
					let index = 0
					for (let i = 0; i < obj.length; i++) {
						let item = obj[i]
						let row = []

						for (let j = 0; j < params.columnsData.length; j++) {
							let column = params.columnsData[j]
							row.push(item[column.index])
							if (column.tipo === 'sumCurrency' || column.tipo === 'sum') {
								undefinedIndexArrayToZero(total, j)
								total[j] += item[column.index]
								undefinedIndexArrayToZero(totalProm, j)
								totalProm[j] += item[column.index]
								index = j
							}
						}

						values.push(row)
					}
					if (idReporte == 6) {
						totalProm[index] = totalProm[index] * 100
					}
					total[lastIndexUndefined(total)] = idReporte == 6 ? "Servicios sucursal #" : "Total Sucursal"
					averageArray(totalProm, obj.length)
					totalProm[lastIndexUndefined(totalProm)] = idReporte == 6 ? "Servicios sucursal %" : "Promedio Sucursal"
					values.push(total)
					values.push(totalProm)
					values.push([''])
				}
			}
			else if (indexGroup.length == 2) {
				groupData = groupArrayOfObjects(params.data, indexGroup[0].index)

				for (let key in groupData) {

					groupData[key] = groupArrayOfObjects(groupData[key], indexGroup[1].index)
					let granTotal = new Array(params.columnsData.length)
					let granTotalProm = new Array(params.columnsData.length)

					let totalLength = 0
					for (let deepKey in groupData[key]) {
						totalLength += groupData[key][deepKey].length
					}
					values.push([key + '(' + totalLength + ')'])
					values.push([''])
					let index = 0

					for (let deepKey in groupData[key]) {

						let obj = groupData[key][deepKey]

						values.push([deepKey + '(' + obj.length + ')'])
						values.push(headers)

						let total = new Array(params.columnsData.length)
						let totalProm = new Array(params.columnsData.length)

						for (let i = 0; i < obj.length; i++) {
							let item = obj[i]
							let row = []

							for (let j = 0; j < params.columnsData.length; j++) {
								let column = params.columnsData[j]
								row.push(item[column.index])
								if (column.tipo === 'sumCurrency' || column.tipo === 'sum') {
									undefinedIndexArrayToZero(total, j)
									total[j] += item[column.index]
									undefinedIndexArrayToZero(totalProm, j)
									totalProm[j] += item[column.index]

									undefinedIndexArrayToZero(granTotal, j)
									granTotal[j] += item[column.index]
									undefinedIndexArrayToZero(granTotalProm, j)
									granTotalProm[j] += item[column.index]
									index = j
								}
							}
							values.push(row)
						}
						if (idReporte == 6) {
							totalProm[index] = totalProm[index] * 100
							granTotalProm[index] = granTotalProm[index] * 100

						}
						total[lastIndexUndefined(total)] = idReporte == 6 ? "Servicios #" : "Total"
						averageArray(totalProm, obj.length)
						totalProm[lastIndexUndefined(totalProm)] = idReporte == 6 ? "Servicios %" : "Promedio"
						values.push(total)
						values.push(totalProm)
						values.push([''])
					}
					granTotal[lastIndexUndefined(granTotal)] = idReporte == 6 ? "Servicios sucursal #" : "Total Sucursal"
					averageArray(granTotalProm, totalLength)
					granTotalProm[lastIndexUndefined(granTotalProm)] = idReporte == 6 ? "Servicios sucursal %" : "Promedio Sucursal"
					values.push(granTotal)
					values.push(granTotalProm)
					values.push([''])
				}
			}
			else if (indexGroup.length == 0) {

			}



			dispatch({ type: 'READY_CSV_DATA_REPORTS', payload: { name: nameCSV, data: values } });

			ready();
		});

	}
};


export const getGlobalData = () => {


	return (dispatch, getState) => {


		dispatch({ type: 'LOADING_REPORTS', payload: true });

		const user = JSON.parse(localStorage.getItem('@@auth_user'));
		request
			.get('/reportes/marcas', { headers: { 'Authorization': `Bearer ${user.token}` } })
			.then((response) => {

				let data = response.data;

				if (!data.error) {

					dispatch({
						type: 'READY_GLOBAL_DATA_REPORTS',
						payload: data.result
					});

				} else {

					if (data.code == -1) {
						localStorage.removeItem('@@auth_user');
						dispatch({
							type: 'ERROR_TOKEN_MAIN',
							payload: { message: data.message, code: -1 }
						})
						dispatch({
							type: 'ERROR_TOKEN_REPORTS',
							payload: data.message
						});
					} else {
						dispatch({
							type: 'ERROR_REPORTS',
							payload: data.message
						});
					}

				}
			})
			.catch((e) => {
				dispatch({
					type: 'ERROR_REPORTS',
					payload: e.message
				});
			});
	}
};


export const resetData = () => {

	return (dispatch, getState) => {

		dispatch({ type: 'RESET_REPORTS' });

	}
};



export const getData = (idReporte, idMarca, idUnidad, anio, mes) => {


	return (dispatch, getState) => {

		let params = getState().reports
		let fecha = params.fecha;
        let anio , mes  = '' ;
		if(params.idReporte ){
			anio = params.anio;
			mes = params.mes;
		}else{
			anio = fecha.format('YYYY');
		    mes =  fecha.format('MM');
		}
	
		dispatch({ type: 'LOADING_REPORTS', payload: true });

		const user = JSON.parse(localStorage.getItem('@@auth_user'));
		request
			.get(params.idReporte ? '/reportes/data' : '/metrico/data',
				{
					params: {
						idReporte: params.idReporte ? params.idReporte : idReporte, idMarca: params.idMarca ? params.idMarca : idMarca
						, idUnidad: params.idUnidad ? params.idUnidad : idUnidad, anio: anio, mes: mes
					}, headers: { 'Authorization': `Bearer ${user.token}` }
				})
			.then((response) => {

				let data = response.data;

				if (!data.error) {

					dispatch({
						type: 'READY_DATA_REPORTS',
						payload: data.result
					});

				}
				else {

					if (data.code == -1) {
						localStorage.removeItem('@@auth_user');
						dispatch({
							type: 'ERROR_TOKEN_MAIN',
							payload: { message: data.message, code: -1 }
						})
						dispatch({
							type: 'ERROR_TOKEN_REPORTS',
							payload: data.message
						});
					} else {
						dispatch({
							type: 'ERROR_REPORTS',
							payload: data.message
						});
					}

				}
			})
			.catch((e) => {
				dispatch({
					type: 'ERROR_REPORTS',
					payload: e.message
				});
			});
	}
};

export const changeFilter = (key, value) => {


	return (dispatch, getState) => {

		dispatch({ type: 'RESET_DATA_REPORTS' });
		dispatch({
			type: 'CHANGE_FILTER_REPORTS',
			payload: { [key]: value }
		});
	}
};